import React from "react";
import Modal from "./Modal";

export default function InfoModal({
  isOpen,
  title,
  description,
  onClose,
  closeLabel = "Close",
  children,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      overlayClassName="bg-slate-950/65 backdrop-blur-sm"
    >
      <div className="w-full max-w-3xl overflow-hidden border border-slate-200 bg-white shadow-[0_28px_80px_rgba(15,23,42,0.2)]">
        <div className="bg-slate-50 px-6 py-5 sm:px-8 sm:py-6">
          {title && (
            <h2 className="text-2xl font-semibold text-slate-900">{title}</h2>
          )}
        </div>
        <div className="px-6 py-6 sm:px-8 sm:py-8">
          {description && (
            <p className="text-sm leading-7 text-slate-700 whitespace-pre-line">
              {description}
            </p>
          )}
          {children && <div className="mt-6">{children}</div>}
          <div className="mt-8 flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center justify-center rounded-full bg-blue-600 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-blue-700"
            >
              {closeLabel}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
